import { Box, Typography } from '@mui/material'
import { Outlet, useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import Sidebar from './Sidebar'
import { NAV_ITEMS } from './navItems'
import dnaVertical from '@/assets/dna_vertical.svg'
import logoHumangenom from '@/assets/logo_humangenom.svg'
import logoMeduni from '@/assets/logo_mui.svg'
import logoGenkom from '@/assets/logo_genkom.png'
import logoDonateAt from '@/assets/DONATE-AT_Transparent.png'
import logoGoE from '@/assets/GoE_Transparent.png'

const GRADIENT = 'linear-gradient(90deg, #e9f7f1 0%, #eff5fa 50%, #d2dcf9 100%)'

const DNA_IMAGES = [
    { top: -50, right: 180, transform: 'rotate(30deg)' },
    { top: 250, left: 0, transform: 'rotate(-30deg)' },
    { top: 1024, left: 0, transform: 'rotate(20deg)' },
    { top: 1024, right: 100, transform: 'rotate(-60deg)' },
]

const LOGOS = [
    { src: logoHumangenom, alt: 'Humangenom Austria', height: 52 },
    { src: logoDonateAt, alt: 'DONATE-AT', height: 52 },
    { src: logoGoE, alt: 'GoE', height: 52 },
    { src: logoMeduni, alt: 'MedUni', height: 60 },
    { src: logoGenkom, alt: 'Genkom', height: 52 },
]

const DesktopLayout = () => {
    const { pathname } = useLocation()
    const { t } = useTranslation()
    const currentItem = NAV_ITEMS.find((item) => item.path === pathname)
    const pageTitle = currentItem?.headerTitle ?? (currentItem ? t(currentItem.labelKey) : '')

    return (
    <Box
        sx={{
            minHeight: '100vh',
            height: '100vh',
            width: '100vw',
            overflow: 'hidden',
            background: GRADIENT,
            position: 'relative',
        }}
    >
        <Typography
            sx={{
                position: 'absolute',
                bottom: 10,
                left: 16,
                fontSize: 11,
                color: 'rgba(0,0,0,0.18)',
                fontFamily: 'monospace',
                letterSpacing: '0.03em',
                zIndex: 0,
                pointerEvents: 'none',
                userSelect: 'none',
            }}
        >
            {__APP_VERSION__ ? `v${__APP_VERSION__} · ` : ''}{__COMMIT_HASH__}
        </Typography>

        {DNA_IMAGES.map((pos, i) => (
            <Box
                key={i}
                component="img"
                src={dnaVertical}
                alt=""
                sx={{
                    position: 'absolute',
                    height: 362,
                    opacity: 0.1,
                    filter: 'grayscale(1) saturate(0.5)',
                    zIndex: 0,
                    pointerEvents: 'none',
                    userSelect: 'none',
                    ...pos,
                }}
            />
        ))}

        <Sidebar />

        <Box
            component="main"
            sx={{
                marginTop: '54px',
                marginLeft: '122px',
                marginBottom: '80px',
                width: 'calc(100vw - 122px)',
                height: 'calc(100vh - 54px - 80px)',
                position: 'relative',
                zIndex: 1,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            {/* Header strip: page title + logos */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingRight: '46px',
                    paddingTop: '32px',
                    paddingBottom: '24px',
                    flexShrink: 0,
                }}
            >
                <Typography
                    sx={{
                        fontFamily: 'Urbanist, sans-serif',
                        fontWeight: 600,
                        fontSize: 36,
                        color: '#3a3a3a',
                        lineHeight: 1.1,
                    }}
                >
                    {pageTitle}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                    {LOGOS.map((logo) => (
                        <Box
                            key={logo.alt}
                            component="img"
                            src={logo.src}
                            alt={logo.alt}
                            sx={{ height: logo.height, width: 'auto', objectFit: 'contain' }}
                        />
                    ))}
                </Box>
            </Box>

            <Box
                sx={{
                    flexGrow: 1,
                    overflowY: 'auto',
                    backgroundColor: 'rgba(255,255,255,1.0)',
                    borderRadius: '12px 32px 32px 32px',
                    paddingLeft: '46px',
                    paddingRight: '46px',
                    paddingTop: '40px',
                    paddingBottom: '40px',
                    marginRight: '46px',
                }}
            >
                <Outlet />
            </Box>
        </Box>
    </Box>
    )
}

export default DesktopLayout
